
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeaveAllocationGrid extends Serenity.EntityGrid<LeaveAllocationRow, any> {
        protected getColumnsKey() { return 'HR.LeaveAllocation'; }
        protected getDialogType() { return LeaveAllocationDialog; }
        protected getIdProperty() { return LeaveAllocationRow.idProperty; }
        protected getInsertPermission() { return LeaveAllocationRow.insertPermission; }
        protected getLocalTextPrefix() { return LeaveAllocationRow.localTextPrefix; }
        protected getService() { return LeaveAllocationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}